export default new Map<string, string>([
  ['1', 'benzina'],
  ['2', 'diesel'],
  ['3', 'gpl'],
  ['4', 'elettrica'],
  ['5', 'altro'],
  ['6', 'ibrida'],
  ['7', 'metano'],
  ['8', 'mild-hybrid-benzina'],
  ['9', 'mild-hybrid-diesel'],
  ['10', 'full-hybrid-benzina'],
  ['11', 'full-hybrid-diesel'],
  ['12', 'ibrido-plugin-benzina'],
  ['13', 'ibrido-plugin-diesel'],
]);
